import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { GetMaterialsValue, MaterialLookup, Materials } from '../models';

export const materialsActions = createActionGroup({
    source: 'Materials',
    events: {
        'Get Materials': props<{ value: GetMaterialsValue }>(),
        'Get Materials Success': props<{ payload: Materials }>(),
        'Get Materials Error': props<{ code: number }>(),

        'Get Materials Lookup': emptyProps(),
        'Get Materials Lookup Success': props<{ payload: MaterialLookup[] }>(),
        'Get Materials Lookup Error': props<{ code: number }>(),

        Clear: emptyProps(),
    },
});
